import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../services/api";
import { showToast } from "../helper/notifications"; // UPDATED IMPORT
import PageHeader from "../components/common/PageHeader";
import { Icon } from "@iconify/react";

const LocationsSubFormPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    type: "",
    parent_id: "",
  });

  const [parentBusinesses, setParentBusinesses] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadOptions();
    if (id) loadSubLocation();
  }, [id]);

  const loadOptions = async () => {
    try {
      const res = await api.get("/options/main-locations");
      setParentBusinesses(res.data || []);
    } catch (err) {
      console.error("Error loading options", err);
    }
  };

  const loadSubLocation = async () => {
    try {
      const res = await api.get(`/sub-locations/${id}`);
      setFormData(res.data);
    } catch {
      // UPDATED: Use showToast for error
      showToast("error", "Failed to load unit");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (id) {
        await api.put(`/sub-locations/${id}`, formData);
        // UPDATED: Use showToast for success
        showToast("success", "Unit updated successfully");
      } else {
        await api.post("/sub-locations", formData);
        // UPDATED: Use showToast for success
        showToast("success", "Unit created successfully");
      }
      navigate("/locations-sub");
    } catch {
      // UPDATED: Use showToast for error
      showToast("error", "Save operation failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageHeader 
        title={id ? "Edit Sub Location" : "Add Sub Location"} 
        subtitle="Management" 
      />

      <div className="card radius-12 border-0 shadow-none bg-base">
        <div className="card-body p-24">
          <form onSubmit={handleSubmit}>
            <div className="row gy-4">
              
              <div className="col-md-6">
                <label className="form-label fw-semibold text-secondary-light">Unit Name</label>
                <input
                  type="text"
                  className="form-control radius-8"
                  placeholder="Enter unit name"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-semibold text-secondary-light">Unit Type</label>
                <input
                  type="text"
                  className="form-control radius-8"
                  placeholder="e.g. Storage, Office, Suite"
                  value={formData.type}
                  onChange={(e) =>
                    setFormData({ ...formData, type: e.target.value })
                  }
                />
              </div>

              <div className="col-12">
                <label className="form-label fw-semibold text-secondary-light">Parent Business</label>
                <select
                  className="form-select radius-8"
                  value={formData.parent_id}
                  onChange={(e) =>
                    setFormData({ ...formData, parent_id: e.target.value })
                  }
                  required
                >
                  <option value="">Select Business</option>
                  {parentBusinesses.map((b) => (
                    <option key={b.id} value={b.id}>
                      {b.location_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-12 d-flex align-items-center justify-content-end gap-3 mt-24">
                <button
                  type="button"
                  className="btn bg-danger-focus text-danger-main px-24 py-11 radius-8 fw-semibold border-0"
                  onClick={() => navigate("/locations-sub")}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  disabled={loading}
                  className="btn btn-primary-600 px-24 py-11 radius-8 fw-semibold d-flex align-items-center gap-2"
                >
                  <Icon icon={loading ? "line-md:loading-twotone-loop" : "lucide:save"} />
                  {id ? "Update Unit" : "Save Unit"}
                </button>
              </div>

            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default LocationsSubFormPage;